import React, { Fragment, useEffect, useState } from "react";
import PendingApprovals from "./PendingApprovals";
import EmissionActivities from "./EmissionActivities";
import FrequentActivities from "./FrequentActivities";
import RecentActivity from "./RecentActivity";
import { useNavigate, useSearchParams } from "react-router-dom";
import { STEPS, SUBSCRIPTION_REDUCER } from "../../constants/enums";
import { useDispatch, useSelector } from "react-redux";
import { checkPermissions, checkSubscriptionPermission } from "../../helper";
import TermsAndConditions from "./TermsAndConditions";
import { Announcement } from "@mui/icons-material";
import Announcements from "./Announcements";
import SetupAppAuthBanner from "../AppAuth/SetupAppAuthBanner";
import CardProvidedDialog from "../Subscription/CardProvidedDialog";
import { updateCardStatus } from "../../services/subscriptionService";

const HomePage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const permissions = useSelector((state: any) => state.auth.userPermissions);
  const plansPermissions = useSelector(
    (state: any) => state.sub.subscriptionPermissions
  );
  // const companyPreferences = useSelector(
  //   (state: any) => state.org.companyPreferences
  // );
  // const userDetails = useSelector((state: any) => state.user.userDetails);
  // const [showAppAuthSetup, setShowAppAuthSetup] = useState(false);
  // useEffect(() => {
  //   if (
  //     Object.keys(companyPreferences).length &&
  //     Object.keys(userDetails).length
  //   ) {
  //     setShowAppAuthSetup(
  //       !!(companyPreferences.app_auth_enabled && !userDetails.appAuthSetup)
  //     );
  //   }
  // }, [companyPreferences, userDetails]);
  const [showTermsAndConditionDialog, setShowTermsAndConditionDialog] =
    useState<any>(JSON.parse(localStorage.getItem("companyPreference") || ""));

  const [showCardProvidedDialog, setShowCardProvidedDialog] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    if (searchParams.has("cardUpdated")) {
      searchParams.delete("cardUpdated");
      searchParams.has("hostedpage_id") && searchParams.delete("hostedpage_id");
      dispatch({
        type: SUBSCRIPTION_REDUCER.SET_FROM_ZOHO_PAYMENTS_PAGE,
        payload: true,
      });
      updateCardStatus().then(() => {});
      setShowCardProvidedDialog(true);
      setSearchParams(searchParams);
    }
  }, []);
  return (
    <div className="flex flex-col gap-2 p-6 bg-neutral-100 h-full overflow-y-auto">
      {/* {showAppAuthSetup && (
        <div>
          <SetupAppAuthBanner />
        </div>
      )} */}
      {
        <div>
          <Announcements />
        </div>
      }
      {checkPermissions(["READ_EMPLOYEE_LIST"], permissions) && (
        <div>
          <PendingApprovals type={"Category"} />
        </div>
      )}
      {checkSubscriptionPermission("ASSETS", plansPermissions) &&
        checkPermissions(["READ_EMPLOYEE_LIST"], permissions) && (
          <div>
            <PendingApprovals type={"Asset"} />
          </div>
        )}
      {checkPermissions(["CREATE_EMISSION"], permissions) && (
        <div>
          <EmissionActivities />
        </div>
      )}
      {checkPermissions(["CREATE_ASSET"], permissions) && (
        <div>
          <div className="text-black text-sm font-bold font-['Proxima Nova']">
            Frequent activities
          </div>
          <FrequentActivities />
        </div>
      )}
      <div>
        <RecentActivity />
      </div>
      {showTermsAndConditionDialog.privacyPolicy === false &&
      showTermsAndConditionDialog.termsAndConditions === false ? (
        <TermsAndConditions
          setShowTermsAndConditionDialog={setShowTermsAndConditionDialog}
        />
      ) : (
        ""
      )}
      {showCardProvidedDialog && (
        <CardProvidedDialog
          open={showCardProvidedDialog}
          onClose={() => {
            setShowCardProvidedDialog(false);
          }}
        />
      )}
    </div>
  );
};

export default HomePage;
